export default __webpack_public_path__ + "static/media/template10.72e44111.svg";